/**
 * Local partners shown in the site-wide footer.
 *
 * Rendered by `components/Footer.jsx` as a small, understated
 * badge/logo strip beneath the main footer nav. Add a new partner by
 * appending to this array — no markup changes required.
 *
 * Field contract:
 *   - name:    Human-readable business name. Used as the `alt` text
 *              and the accessible name for the anchor. Must not be
 *              empty.
 *   - logoSrc: Path relative to `frontend/public/`. Keep logo files
 *              under `public/images/partners/`. PNGs preferred for
 *              circular/badge-style marks with transparency; SVG is
 *              fine when vendor provides one.
 *   - href:    Full absolute URL. Always opens in a new tab with
 *              rel="noopener noreferrer" (enforced by the Footer
 *              component, not by this config).
 */
export const LOCAL_PARTNERS = [
  {
    name: "Camp Bow Wow Tampa South Shore",
    logoSrc: "/images/partners/camp-bow-wow.png",
    href: "https://www.campbowwow.com/tampa-south-shore/",
  },
];
